import { render, staticRenderFns } from "./AssignRolePopup.vue?vue&type=template&id=79c7b04d&"
import script from "./AssignRolePopup.vue?vue&type=script&lang=ts&"
export * from "./AssignRolePopup.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./AssignRolePopup.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports